
import React from 'react';
import { Search } from 'lucide-react';

interface SearchSuggestionsProps {
  suggestions: string[];
  searchQuery: string;
  highlightedIndex: number;
  onSuggestionClick: (suggestion: string) => void;
  onMouseEnter: (index: number) => void;
}

const SearchSuggestions: React.FC<SearchSuggestionsProps> = ({ 
  suggestions,
  searchQuery,
  highlightedIndex,
  onSuggestionClick,
  onMouseEnter
}) => {
  const highlightMatch = (suggestion: string, query: string) => {
    if (!query) return suggestion;
    
    const lowerSuggestion = suggestion.toLowerCase();
    const lowerQuery = query.toLowerCase();
    const index = lowerSuggestion.indexOf(lowerQuery);
    
    if (index === -1) return suggestion;
    
    return (
      <>
        {suggestion.substring(0, index)}
        <strong className="font-bold text-primary">
          {suggestion.substring(index, index + query.length)}
        </strong>
        {suggestion.substring(index + query.length)}
      </>
    );
  };

  if (suggestions.length === 0) return null;

  return (
    <div>
      <div className="px-4 py-2 text-xs font-semibold text-muted-foreground border-b border-border bg-muted/20">
        Suggestions
      </div>
      <ul>
        {suggestions.map((suggestion, index) => (
          <li 
            key={index}
            className={`px-4 py-3 flex items-center cursor-pointer hover:bg-muted transition-colors ${
              index === highlightedIndex ? 'bg-muted' : ''
            }`}
            onClick={() => onSuggestionClick(suggestion)}
            onMouseEnter={() => onMouseEnter(index)}
          >
            <Search className="h-4 w-4 mr-3 text-muted-foreground" />
            <span className="text-foreground">{highlightMatch(suggestion, searchQuery)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchSuggestions;
